import{jsxs as t,Fragment as e,jsx as o}from"react/jsx-runtime";import{Fragment as n}from"react";import{styled as p}from"styled-components";import{FunctionItem as i}from"./FunctionItem.mjs";import{useItemName as m}from"../../../../domain/hooks/useItemName.mjs";const r=p.h3.attrs({className:"function-block-title"})`
  padding: 4px 4px 0px 2px;
  border-bottom: 2px solid #3db9ac;
  margin: 1em 24px 8px 0px;
  font-size: 15px;
  font-weight: normal;
  text-indent: 8px;
  text-shadow: 1px 1px 2px #999999;
  background: url(images/tab.png) #f7f7f7 no-repeat;
`,a=p.h4.attrs({className:"function-sub-block-title"})`
  padding-bottom: 4px;
  border-bottom: 1px dotted #cccccc;
  margin: 1.33em 24px 8px 0px;
  font-size: 13px;
  font-weight: normal;
  text-shadow: 1px 1px 2px #999999;
`,s=p.ul.attrs({className:"item-list"})`
  font-size: 13px;
  padding: 0px;
  margin: 0px;
  list-style-type: none;
`;function x({title:p,items:x,subBlocks:l}){const c=m();return t(e,{children:[o(r,{children:c(p)}),t(s,{children:[null==x?void 0:x.map((t=>o(i,{...t},t.path))),null==l?void 0:l.map(((e,p)=>0!==e.items.length?t(n,{children:[o(a,{children:c(e.title)}),e.items.map((t=>o(i,{...t},t.path)))]},p):o(n,{},p)))]})]})}export{x as FunctionBlock};
